jQuery(document).ready(function ($) {
    $(function () {

        // Mobile Nav 
        $('.menu-toggle').click(function(){
            $('body').addClass('show-Mobile');
        });
        
        $('.close-Mobile, .site-content').click(function(){
            $('body').removeClass('show-Mobile');
        });
        
        $('.search-form').addClass('closed');
        $('.open-search').click(function () {
            if ($('.search-form').hasClass('open')) {
                $('.search-form').addClass('closed');
                $('.search-form').removeClass('open');
            } else {
                $('.search-form').removeClass('closed');
                $('.search-form').addClass('open');
            }
        });

        // Sticky Nav
        var mn = $("body");
        mns = "main-nav-scrolled";
        hdr = $('.scrollheader').height();

        $(window).scroll(function () {
            if ($(this).scrollTop() > 0) {
                mn.addClass(mns);
            } else {
                mn.removeClass(mns);
            }
        });

        // Slider
        $('.owl-slider-caption').owlCarousel({
            loop:true,
            items: 1,
            autoplay: true,
            autoplayHoverPause: true,
            autoplaySpeed:2000,
            nav: true,
            navText: ['<i class="fas fa-angle-left"></i>', '<i class="fas fa-angle-right"></i>'],
            dots: true,
            
        });

        $('.owl-test').owlCarousel({
            loop:true,
            items: 1,
            autoplay:true,
            autoplayHoverPause:true,
            autoplaySpeed:2000,
            dots: true,
        });

        // Tab Carousel
        function owlInitialize() {
            
            $('.loop-carousel').owlCarousel({
                center: true,
                items:1,
                dots: false,
                loop:true,
                margin:10,
                
                responsive:{
                    0:{
                        stagePadding: 20,
                    },
                    450: {
                        stagePadding: 65,
                    }
                    
                },
            });
            
         }
         
        owlInitialize();
         
        

        // Counter
        if ( window.location.pathname == '/' || window.location.pathname == '/our-family/' ){
            var a = 0;
            $(window).scroll(function () {

                var oTop = $('#counter').offset().top - window.innerHeight;
                if (a == 0 && $(window).scrollTop() > oTop) {
                    $('.counter-value').each(function () {
                        var $this = $(this),
                            countTo = $this.attr('data-count');
                        $({
                            countNum: $this.text()
                        }).animate({
                                countNum: countTo
                            },

                            {

                                duration: 2000,
                                easing: 'swing',
                                step: function () {
                                    $this.text(Math.floor(this.countNum));
                                },
                                complete: function () {
                                    $this.text(this.countNum);
                                    //alert('finished');
                                }

                            });
                    });
                    a = 1;
                }

            });
        }

        // Forms
        $('#gform_1').addClass('toggle-labels');
        $('#gform_1 .gform_body input, #gform_1 .gform_body textarea').unwrap();
        $("#gform_1 .gform_body input, #gform_1 .gform_body textarea").focus(function () {
            $(this).parent().addClass('active');
        });
        $("#gform_1 .gform_body input, #gform_1 .gform_body textarea").focusout(function () {
            if ($(this).val() !== '') {

            } else {
                $(this).parent().removeClass('active');
            }
        });
        $("#gform_1 .gform_body").on('change', 'input[type="text"], #gform_1 .gform_body textarea', function () {
            if ($(this).val() !== '') {
                if ($(this).siblings('label').length) {
                    $(this).parent().addClass('active');
                } else {
                    $(this).parent().parent().addClass('active');
                }
            }
        });

       // Tabs
       $('.nav-tabs li:first-child').addClass('active');
       $('.tab-content .tab-pane:first-child').addClass('active');
       $('.nav-arrows .prev').click(function () {
           if ($(this).closest('.tab-pane').prev('.tab-pane').length) {
               $(this).closest('.tab-pane').removeClass('active');
               $(this).closest('.tab-pane').prev('.tab-pane').addClass('active');
               $('.nav-tabs li.active').removeClass('active').prev().addClass('active');
           } else {
               $(this).closest('.tab-pane').removeClass('active');
               $('.tab-pane:last-child').addClass('active');
               $('.nav-tabs li.active').removeClass('active');
               $('.nav-tabs li:last-child').addClass('active')
           }
       });
       $('.nav-arrows .next').click(function () {
           if ($(this).closest('.tab-pane').next('.tab-pane').length) {
               $(this).closest('.tab-pane').removeClass('active');
               $(this).closest('.tab-pane').next('.tab-pane').addClass('active');
               $('.nav-tabs li.active').removeClass('active').next().addClass('active');
           } else {
               $(this).closest('.tab-pane').removeClass('active');
               $('.tab-pane:first-child').addClass('active');
               $('.nav-tabs li.active').removeClass('active');
               $('.nav-tabs li:first-child').addClass('active')
           }


       });

        // Scroll Revel
        
        var slideUp = {
            distance: '50px',
            origin: 'bottom',
            duration: 2000,
            scale: .98
            
        };
        
        ScrollReveal().reveal('.section-revel .container', slideUp);
        ScrollReveal().reveal('.components section .container', slideUp);

        +
        function ($) {
            'use strict';

            // TAB CLASS DEFINITION
            // ====================

            var Tab = function (element) {
                // jscs:disable requireDollarBeforejQueryAssignment
                this.element = $(element)
                // jscs:enable requireDollarBeforejQueryAssignment
            }

            Tab.VERSION = '3.3.6'

            Tab.TRANSITION_DURATION = 150

            Tab.prototype.show = function () {
                var $this = this.element
                var $ul = $this.closest('ul:not(.dropdown-menu)')
                var selector = $this.data('target')

                if (!selector) {
                    selector = $this.attr('href')
                    selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
                }

                if ($this.parent('li').hasClass('active')) return

                var $previous = $ul.find('.active:last a')
                var hideEvent = $.Event('hide.bs.tab', {
                    relatedTarget: $this[0]
                })
                var showEvent = $.Event('show.bs.tab', {
                    relatedTarget: $previous[0]
                })

                $previous.trigger(hideEvent)
                $this.trigger(showEvent)

                if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

                var $target = $(selector)

                this.activate($this.closest('li'), $ul)
                this.activate($target, $target.parent(), function () {
                    $previous.trigger({
                        type: 'hidden.bs.tab',
                        relatedTarget: $this[0]
                    })
                    $this.trigger({
                        type: 'shown.bs.tab',
                        relatedTarget: $previous[0]
                    })
                })
            }

            Tab.prototype.activate = function (element, container, callback) {
                var $active = container.find('> .active')
                var transition = callback &&
                    $.support.transition &&
                    ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

                function next() {
                    $active
                        .removeClass('active')
                        .find('> .dropdown-menu > .active')
                        .removeClass('active')
                        .end()
                        .find('[data-toggle="tab"]')
                        .attr('aria-expanded', false)

                    element
                        .addClass('active')
                        .find('[data-toggle="tab"]')
                        .attr('aria-expanded', true)

                    if (transition) {
                        element[0].offsetWidth // reflow for transition
                        element.addClass('in')
                    } else {
                        element.removeClass('fade')
                    }

                    if (element.parent('.dropdown-menu').length) {
                        element
                            .closest('li.dropdown')
                            .addClass('active')
                            .end()
                            .find('[data-toggle="tab"]')
                            .attr('aria-expanded', true)
                    }

                    callback && callback()
                }

                $active.length && transition ?
                    $active
                    .one('bsTransitionEnd', next)
                    .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
                    next()

                $active.removeClass('in')
            }


            // TAB PLUGIN DEFINITION
            // =====================

            function Plugin(option) {
                return this.each(function () {
                    var $this = $(this)
                    var data = $this.data('bs.tab')

                    if (!data) $this.data('bs.tab', (data = new Tab(this)))
                    if (typeof option == 'string') data[option]()
                })
            }

            var old = $.fn.tab

            $.fn.tab = Plugin
            $.fn.tab.Constructor = Tab


            // TAB NO CONFLICT
            // ===============

            $.fn.tab.noConflict = function () {
                $.fn.tab = old
                return this
            }


            // TAB DATA-API
            // ============

            var clickHandler = function (e) {
                e.preventDefault()
                Plugin.call($(this), 'show')
            }

            $(document)
                .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
                .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

        }(jQuery);



    }); //end anonymous function
}); //end document ready

